import React, { forwardRef } from "react";
import { IconButton, IconButtonProps } from "@mui/material";
import {
  IconButtonVariant,
  IconButtonSize,
} from "@/modules/common/components/ui-kit/buttons/shared/types";
import { getBaseStyles } from "@/modules/common/components/ui-kit/buttons/shared/utils";

export interface CommonIconButtonProps extends Omit<IconButtonProps, "size"> {
  children: React.ReactNode;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
}

const CommonIconButton = forwardRef<HTMLButtonElement, CommonIconButtonProps>(
  ({ children, variant = "primary", size = "md", sx, ...props }, ref) => {
    return (
      <IconButton
        ref={ref}
        sx={{
          ...getBaseStyles(variant, size, "icon-button"),
          ...(sx as object),
        }}
        {...props}
      >
        {children}
      </IconButton>
    );
  }
);

CommonIconButton.displayName = "CommonIconButton";

export default CommonIconButton;
